module.exports = __webpack_public_path__ + "img/mx-flag.0335b860.png";